import React, { useEffect, useState } from "react";
import styles from "./diagramComment.module.css";
interface PropType {
  index: number;
  text: string;
  setText: Function;
  setTo: Function;
  relation: "upper" | "lower" | "middle";
  setRelation: Function;
  cols: number;
}

export const AnnotationSelectCol = ({
  index,
  text,
  setText,
  setTo,
  setRelation,
}: PropType) => {
  const [upperBound, toggleUpperBound] = useState<boolean>(false);
  const [lowerBound, toggleLowerBound] = useState<boolean>(false);
  const [lowerText, setLowerText] = useState<number | null>(null);
  const [upperText, setUpperText] = useState<number | null>(null);

  useEffect(() => {
    if (lowerBound === false) {
      setLowerText(null);
      setTo(0);
      setRelation("middle");
    }
  }, [lowerBound]);

  useEffect(() => {
    if (upperBound === false) {
      setUpperText(null);
      setTo(0);
      setRelation("middle");
    }
  }, [upperBound]);

  useEffect(() => {
    if (!upperBound && !lowerBound) {
      setRelation("middle");
    } else if (upperBound && !lowerBound) {
      setRelation("upper");
    } else if (!upperBound && lowerBound) {
      setRelation("lower");
    }
  }, [upperBound, lowerBound]);

  useEffect(() => {
    if (!upperBound && !lowerBound && !upperText && !lowerText) {
      setText(`Merke på kolonne ${index}`);
    } else if (lowerText) {
      setText(`Merke på kolonner ${index} - ${lowerText}`);
    } else if (upperText) {
      setText(`Merke på kolonner ${upperText} - ${index}`);
    } else if (upperBound && !lowerText) {
      setText(`Merke før kolonne ${index}`);
    } else if (lowerBound && !upperText) {
      setText(`Merke etter kolonne ${index}`);
    }
  }, [lowerText, upperText, upperBound, lowerBound]);

  useEffect(() => {
    setTo(upperText);
  }, [upperText]);

  useEffect(() => {
    setTo(lowerText);
  }, [lowerText]);

  return (
    <div className={styles.intervalContainer}>
      <div>{text}</div>
      <div className={styles.interval}>
        <div className={styles.colGroup}>
          <div
            onClick={() => {
              toggleLowerBound(!lowerBound);
              toggleUpperBound(false);
            }}
            className={`${styles.col} ${lowerBound && styles.colActive}`}
          />
          <div className={styles.middle}>{index}</div>
          <div
            onClick={() => {
              toggleUpperBound(!upperBound);
              toggleLowerBound(false);
            }}
            className={`${styles.col} ${upperBound && styles.colActive}`}
          />
        </div>
        <div className={styles.colGroup}>
          <div>
            <input
              placeholder={`${index - 1}`}
              disabled={lowerBound || upperBound}
              className={styles.intervalInput}
              value={lowerText ?? 0}
              onChange={(e) => {
                setLowerText(
                  isNaN(parseInt(e.target.value)) ? 0 : parseInt(e.target.value)
                );
              }}
            />
          </div>
          <div
            onClick={() => {
              toggleLowerBound(!lowerBound);
              toggleUpperBound(false);
            }}
            className={`${styles.col}`}
          />
        </div>
      </div>
    </div>
  );
};
